import { NATIVE_USDC_HELP_TEXT } from '@/hooks/useCustomContent';

import { Badge } from '@/ui/Badge';
import { VerificationIcon } from '@/ui/Icons/VerificationIcon';
import {
  MatchaTooltip,
  MatchaTooltipBottomSheet,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '@/ui/MatchaTooltip';

interface IssuedByCircleBadgeProps {
  className?: string;
  clickable?: boolean;
}

export const IssuedByCircleBadge = ({ className, clickable }: IssuedByCircleBadgeProps) => {
  return (
    <MatchaTooltip>
      <MatchaTooltipTrigger>
        <span className={className}>
          <Badge
            role="tooltip"
            variant="neutralOutline"
            aria-label="Issued by Circle"
            aria-describedby="nativeUsdcHelpText"
            style={clickable ? { cursor: 'pointer' } : {}}
          >
            <span className="flex items-center gap-0.5">
              <VerificationIcon className="size-2.5 text-token-gray-700 shrink-0" />
              Issued by Circle
            </span>
          </Badge>
        </span>
      </MatchaTooltipTrigger>
      <MatchaTooltipContent>
        <span id="nativeUsdcHelpText">{NATIVE_USDC_HELP_TEXT}</span>
      </MatchaTooltipContent>
      <MatchaTooltipPopover
        sideOffset={8}
        className="max-w-[246px] inline-block tablet:text-center"
      />
      <MatchaTooltipBottomSheet header="Issued by Circle" />
    </MatchaTooltip>
  );
};
